export default {
  loading: false,
  survey: null,
  surveyResults: null,
  surveyAdditionalScores: null,
  confirmationAnswers: {},
}
